class PageHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 40
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('page-header')) {
  customElements.define('page-header', PageHeader)
}
